import useDetectScroll from "@smakss/react-scroll-direction";

import { Grid, Header, Icon, Ref } from "semantic-ui-react";

import React, { useRef, useState } from "react";
import useWindowSize from "react-use/lib/useWindowSize";

import useBoundingClientRect from "astrid-hooks/src/useBoundingClientRect";

import Flex from "../../../../components/Flex/Flex";
import Section from "../../../ui/components/Section/Section";

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Button from "../../components/Buttons/Button";
import themeColors from "../../constants/themeColors";
import useDocTitle from "../../hooks/useDocTitle";
import truncateString from "../../utils/truncateString";

const offset = 80;

export default function PageView({
	image,
	header,
	breadcrumbs,
	subheader,
	extra,
	sidebar,
	sidebarWidth = 3,
	maxWidth,
	children,
}) {
	useDocTitle(header);

	const headerRef = useRef();

	const { top, height } = useBoundingClientRect(headerRef);

	const { width } = useWindowSize();
	const { scrollPosition } = useDetectScroll();

	const [showSidebar, setShowSidebar] = useState(true);

	const large = width > 600;

	const transition = large && top && height ? (scrollPosition.top > top - (offset - height) ? 1 : 0) : 0;

	const sidebarStyle = {
		position: "sticky",
		zIndex: 1,
		top: offset,
		marginTop: -height,
	};

	const sidebarHeaderStyle = {
		opacity: transition,
		transformOrigin: "0 0",
		transition: "opacity 0.2s",
	};

	return (
		<>
			{breadcrumbs && (
				<Section
					style={{ padding: "10px 0", marginTop: -10 }}
					maxWidth={maxWidth || (!sidebar && 1000) || undefined}
				>
					<Breadcrumbs breadcrumbs={breadcrumbs} />
				</Section>
			)}

			{header && (
				<Section maxWidth={maxWidth || (!sidebar && 1000) || undefined}>
					<Flex gap={5} justifyContent="flex-start">
						<Flex wrap={!large} gap={15} justifyContent="flex-start">
							<Flex gap={15} justifyContent="flex-start">
								{image}

								<Section.Header style={{ marginRight: "auto", fontSize: large ? "2rem" : "1.6rem" }}>
									{header}

									{subheader && <Section.SubHeader>{subheader}</Section.SubHeader>}
								</Section.Header>
							</Flex>

							{extra}
						</Flex>
					</Flex>
				</Section>
			)}

			<Section maxWidth={maxWidth || (!sidebar && 1000) || undefined}>
				{sidebar && (
					<Button
						icon
						circular
						size="mini"
						style={{
							lineHeight: "15px",
							padding: "2px  10px",
							position: "absolute",
							top: "-10px",
							zIndex: 10,
							color: themeColors.GREY,
							backgroundColor: "var(--color-bg-input)",
							border: `1px solid ${themeColors.BORDER}`,
						}}
						onClick={() => setShowSidebar((value) => !value)}
					>
						<Icon link fitted name={showSidebar ? "chevron left" : "chevron right"} />
					</Button>
				)}

				<Grid relaxed>
					{sidebar && (
						<Grid.Column width={large ? sidebarWidth : 16} style={{ paddingTop: 5, display: showSidebar ? undefined : "none" }}>
							<div style={sidebarStyle}>
								<Ref innerRef={headerRef}>
									<Header as="h3" style={sidebarHeaderStyle}>
										{truncateString(header, 25)}
									</Header>
								</Ref>

								{sidebar}
							</div>
						</Grid.Column>
					)}

					<Grid.Column
						width={large && sidebar && showSidebar ? 16 - sidebarWidth : 16}
						style={{ paddingTop: 20 }}
					>
						{children}
					</Grid.Column>
				</Grid>
			</Section>
		</>
	);
}
